var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOvelCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 49,
    viewBox: "0 0 86 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.059 12.1148V87.4335H-93.5818C-96.5126 87.4306 -99.3226 86.2688 -101.395 84.2031C-103.467 82.1373 -104.633 79.3364 -104.636 76.4149V60.7819C-104.636 60.7819 -90.2288 22.3679 -66.5955 22.3679C-42.9623 22.3679 -41.2317 63.3371 -14.6781 63.3371C-9.12939 63.3371 -4.53253 58.5825 -0.162819 51.704C11.2374 33.7531 21.0693 1.34424 42.3987 1.34424C48.3119 1.34064 54.0004 3.60254 58.2876 7.66213C73.7114 21.4515 78.0054 53.0948 89.5462 53.0948C95.3328 53.0948 99.5728 46.7662 103.369 39.079C109.221 27.2195 114.056 12.1148 122.059 12.1148Z",
    fill: "#FBFDFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6751 24.3234L36.6972 29.3013C36.511 29.4876 36.2739 29.5807 35.9861 29.5807C35.6983 29.5807 35.4612 29.4876 35.275 29.3013C35.0887 29.1151 34.9956 28.878 34.9956 28.5902C34.9956 28.3023 35.0887 28.0653 35.275 27.8791L40.2529 22.9012L35.275 17.9233C35.0887 17.7371 34.9956 17.5 34.9956 17.2122C34.9956 16.9243 35.0887 16.6873 35.275 16.501C35.4612 16.3148 35.6983 16.2217 35.9861 16.2217C36.2739 16.2217 36.511 16.3148 36.6972 16.501L41.6751 21.4789L46.653 16.501C46.8392 16.3148 47.0763 16.2217 47.3641 16.2217C47.6519 16.2217 47.889 16.3148 48.0752 16.501C48.2615 16.6873 48.3546 16.9243 48.3546 17.2122C48.3546 17.5 48.2615 17.7371 48.0752 17.9233L43.0974 22.9012L48.0752 27.8791C48.2615 28.0653 48.3546 28.3023 48.3546 28.5902C48.3546 28.878 48.2615 29.1151 48.0752 29.3013C47.889 29.4876 47.6519 29.5807 47.3641 29.5807C47.0763 29.5807 46.8392 29.4876 46.653 29.3013L41.6751 24.3234Z",
    fill: "#113799"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85.4475,
    height: 48.2964,
    fill: "white",
    transform: "translate(0.517212 0.604492)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvelCross);
export default __webpack_public_path__ + "static/media/ovelCross.48b98c8739b659a3b7829a0b44eff373.svg";
export { ForwardRef as ReactComponent };